angular.module('unica_event.event_controllers')

.controller('EventTextsController',
	function(
		$rootScope, $scope, $state, $stateParams, $timeout,
		$confirm, FileUploader, getBaseApiURL, Session, $window,
		EventEditService
	) {

	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $scope.event_id );

	$scope.$on('event_loaded', function() {
		// $scope.checkPreviewSite();
	});


	$scope.checkTextsForm = function()
	{
		if ( !$scope.forms.texts_form.$invalid &&
			$rootScope.eventData ) {
			return false;
		}
		return true;
	};


	$scope.saveTexts = function()
	{
		$scope.showLoader();

		if ( $rootScope.eventData.cover && $rootScope.eventData.cover.dataURL ) {
			$rootScope.eventData.cover = $rootScope.eventData.cover.dataURL;
		}

		if ( $rootScope.eventData.logo && $rootScope.eventData.logo.dataURL ) {
			$rootScope.eventData.logo = $rootScope.eventData.logo.dataURL;
		} else {
			$rootScope.eventData.logo = '';
		}

		var eventData = angular.copy($rootScope.eventData);

		console.log(eventData);


		EventEditService
			.updateTexts( eventData)
			.then(function() {
				$scope.hideLoader();

				$rootScope.getEvent( eventData.id );

				$scope.showSuccessMsg('Testi aggiornati con successo!', '');
				$state.go('saveSite', { id: $rootScope.eventData.id });
		});
	};

});
